module.exports = __webpack_public_path__ + "static/media/background.6bd7db3b.jpg";